import StreamOutputStatusErrorLine from './error_line.jsx';

function srtCells(srt_socket, peer_log) {
  if (!srt_socket) return <></>;

  const lg = peer_log || {};
  return <>
    <div className="flex m-px border-gray-200 border rounded-md">
      <div className="px-2 w-18 bg-gray-100 rounded-l-md">RTT:</div>
      <div className="px-2 w-20">{srt_socket.msRTT.toFixed(1)}ms</div>
    </div>
    <div className="flex m-px border-gray-200 border rounded-md"
         title={`too-late-to-send dropped; total since connect: ${srt_socket.pktSndDropTotal}`}>
      <div className="px-2 w-24 bg-gray-100 rounded-l-md">SRT drop:</div>
      <div className="px-2 w-72">
        {lg.srt_dropped_60 || 0}/1m {lg.srt_dropped_600 || 0}/10m {lg.srt_dropped_hour || 0}/60m
      </div>
    </div>
    <div className="flex m-px border-gray-200 border rounded-md"
         title={`lost on link (receiver NAKs); total since connect: ${srt_socket.pktSndLossTotal}`}>
      <div className="px-2 w-24 bg-gray-100 rounded-l-md">SRT loss:</div>
      <div className="px-2 w-72">
        {lg.srt_loss_60 || 0}/1m {lg.srt_loss_600 || 0}/10m {lg.srt_loss_hour || 0}/60m
      </div>
    </div>
    <div className="flex m-px border-gray-200 border rounded-md"
         title={`retransmitted; total since connect: ${srt_socket.pktRetransTotal}`}>
      <div className="px-2 w-24 bg-gray-100 rounded-l-md">SRT retr:</div>
      <div className="px-2 w-72">
        {lg.srt_retrans_60 || 0}/1m {lg.srt_retrans_600 || 0}/10m {lg.srt_retrans_hour || 0}/60m
      </div>
    </div>
  </>;
}

export default function StreamOutputStatusConnectionsList({ status, log_state }) {
  if (status.connections.length == 0) {
    return <StreamOutputStatusErrorLine error_message="no connections" />;
  }

  const listConnections = status.connections.map(conn =>
    <div className="flex flex-wrap m-px">
      <div className="flex m-px px-2 border-gray-200 border rounded-md w-auto lg:w-48">
        {conn.peer}
      </div>
      <div className="flex m-px px-2 w-36 border-gray-200 border rounded-md">
        {conn.write_rate}k
      </div>
      <div className="flex m-px px-2 w-36 border-gray-200 border rounded-md">
        {conn.uptime_s}
      </div>
      {srtCells(conn.srt_socket, (log_state || {})[conn.peer])}
    </div>
  )
  return <>{listConnections}</>;
}
